module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurSmall/Baptiste_1.bcb0802.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurSmall/Baptiste_1.jpg
// module id = 6MFd
// module chunks = 0